import { cn } from '@theprintbar/shared';

interface ColourSwatchProps {
	colour: {
		hex: string;
		secondaryHex?: string | null;
	};
	className?: string;
	noBorder?: boolean;
	small?: boolean;
}

export function ColourSwatch({ colour, className, noBorder, small }: ColourSwatchProps) {
	const { hex, secondaryHex } = colour;
	return (
		<div
			className={cn(
				'w-fit rounded-full transition-all duration-75 ease-in-out',
				!noBorder && 'border p-1',
				small && 'p-0.5',
				className,
			)}
		>
			<div
				className={cn('rounded-full', small ? 'w-2 h-2 lg:w-3 lg:h-3' : 'w-4 h-4 lg:w-5 lg:h-5')}
				style={{
					background: secondaryHex ? `linear-gradient( -45deg, ${hex} 49%, white 49%, white 51%, ${secondaryHex} 51% )` : hex,
				}}
			/>
		</div>
	);
}
